<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">

        <!-- Header -->
        <div class="row align-items-center py-3">
          <div class="col-md-6">
            <p class="appTitle mb-0">Add Courses for College</p>
          </div>
          <div class="col-md-6 text-end">
            <div class="admin-info d-inline-flex align-items-center">
              <span class="adminName me-2">{{ adminName }}</span>
              <img width="36" height="36" src="assets/tenant-avatar.jpg" class="rounded-circle" alt="Admin" />
            </div>
          </div>
        </div>
        <!-- /Header -->

        <!-- Search + Page size + Add button -->
        <div class="row my-3 align-items-center">
          <div class="col-md-6">
            <div class="search-wrapper position-relative">
              <input
                class="form-control search-input"
                (input)="onQuickFilterChanged($event.target.value)"
                type="text"
                placeholder="🔍 Search College or Course..."
                [(ngModel)]="searchval"
              />
              <button class="clear-btn" *ngIf="searchval" (click)="reset()">✖</button>
            </div>
          </div>

        

          <div class="col-md-3 text-end">
            <button type="button" class="btn btn-primary addCourseBtn" (click)="openAdd()">
              <i class="fa fa-plus"></i> Add Courses
            </button>
          </div>
        </div>
        <!-- /Search + controls -->

        <!-- AG Grid -->
        <div class="tableView my-3" *ngIf="showData">
          <div class="ag-theme-alpine ag-table-custom bg-gray" style="width:100%;height:640px;">
           <ag-grid-angular
  #agGrid
  class="ag-theme-alpine"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [rowData]="rowData"
  [gridOptions]="gridOptions"
  [groupDisplayType]="'groupRows'"
  (gridReady)="onGridReady($event)"
  rowSelection="single"
  style="width:100%;height:600px;"
></ag-grid-angular> 

          </div>
        </div>

        <!-- No data -->
        <div class="noData text-center my-4" *ngIf="!rowData || rowData.length === 0">
          <h2>Currently No Data Available!</h2>
        </div>

        <!-- Add/Edit Modal -->
        <div class="backdrop" [ngStyle]="{'display':display}"></div>
        <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header" *ngIf="showAdd">
                <h5 class="modal-title">Add Courses</h5>
                <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-header" *ngIf="showEdit">
                <h5 class="modal-title">Edit Courses</h5>
                <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="dltmodal-content animate modal-body dltBl">
                <form [formGroup]="courseaddForm" (ngSubmit)="showAdd ? addCourses() : updateCourses()">
                  <div *ngIf="showAdd">
                    <label>Select College</label>
                    <select class="form-control" formControlName="collegeName" [(ngModel)]="collegeId">
                      <option *ngFor="let college of colleges" [ngValue]="college.id">{{ college.collage_name }}</option>
                    </select>

                    <div class="mb-3">
                      <label>Courses</label>
                      <div class="row">
                        <ng-container *ngFor="let scope of scopeData; let i = index">
                          <div class="col-md-4 mb-2">
                            <div class="checkboxDesign">
                              <input type="checkbox" formControlName="checkVal" [(ngModel)]="scope.check"
                                class="form-check-input" [ngValue]="scope.id" (change)="onCheckChange($event)" />
                              <span>{{ scope.degree }} - {{ scope.courses }}</span>
                            </div>
                          </div>

                          <div class="col-md-4 mb-2">
                            <label>Fees</label>
                            <input type="text" class="form-control" [ngStyle]="{'pointer-events': scope.check ? 'auto' : 'none'}"
                              [(ngModel)]="scope.fees" [ngModelOptions]="{standalone: true}" />
                          </div>

                          <div class="col-md-4 mb-2">
                            <label>Trust Fees</label>
                            <input type="text" class="form-control" [ngStyle]="{'pointer-events': scope.check ? 'auto' : 'none'}"
                              [(ngModel)]="scope.trustFees" [ngModelOptions]="{standalone: true}" />
                          </div>
                        </ng-container>
                      </div>
                    </div>

                    <div class="addBtn">
                      <button class="commonBtn mt-2 btn btn-success" [disabled]="!courseaddForm.valid" type="submit">
                        Add Courses
                      </button>
                    </div>
                  </div>

                  <div *ngIf="showEdit">
                    <label>College</label>
                    <input type="text" class="form-control" formControlName="collegeName" [(ngModel)]="collegeId" />

                    <label>Courses</label>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="checkboxDesign">
                          <input type="checkbox" formControlName="checkVal" [(ngModel)]="courseName" class="form-check-input" (change)="onCheckChange($event)" />
                          <span>{{ courseName }}</span>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <label>Fees</label>
                        <input type="text" class="form-control" formControlName="feesVal" [(ngModel)]="fees" [ngModelOptions]="{standalone: true}" />
                      </div>
                      <div class="col-md-4">
                        <label>Trust Fees</label>
                        <input type="text" class="form-control" formControlName="trustFeesVal" [(ngModel)]="trustFees" [ngModelOptions]="{standalone: true}" />
                      </div>
                    </div>

                    <div class="addBtn" *ngIf="showEdit">
                      <button class="commonBtn mt-2 btn btn-primary" [disabled]="!courseaddForm.valid" type="submit">Update</button>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
        <!-- /Add/Edit Modal -->

        <!-- Delete confirm modal -->
        <div class="backdrop" [ngStyle]="{'display':displayDelete}"></div>
        <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':displayDelete}">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body text-center">
                <p>Do you want to delete the Course ?</p>
                <div class="d-flex justify-content-center gap-2">
                  <button type="button" class="btn btn-success" (click)="delete()">Yes</button>
                  <button type="button" class="btn btn-danger" (click)="onCloseHandled()">No</button>
                </div>
                <p class="error mt-2" *ngIf="showErr">{{ deleteErr }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete modal -->

      </div> <!-- /.container -->
    </div> <!-- /.bgColor -->
  </main>
</div>
